import {forwardRef} from "react";
import {t} from "i18next";
import {FormLabel} from "./FormLabel";
import {RadioGroup} from "./RadioGroup";
import {Radio} from "./Radio";

interface XAlternativesFormProps {
    displayValue: string;
    objects: Record<string, any>;
    formObject: {data: {heading?: string; name?: string}; children: string[]};
    id: string;
    onChange: (value: string) => void;
    onFocus?: (e: any) => void;
    onBlur?: (e: any) => void;
    hasFocus?: boolean;
}

export const XAlternativesForm = forwardRef<
    HTMLLabelElement,
    XAlternativesFormProps
>(({displayValue, objects, formObject, onChange, onFocus, onBlur, hasFocus}, ref) => {
    const label =
        formObject.data.heading ||
        t("DocumentGenerator.ChooseAlternative", "Velg et alternativ");

    const childIds = formObject.children;

    return (
        <FormLabel value={label} active={hasFocus} ref={ref}>
            <RadioGroup
                value={displayValue}
                onChange={onChange}
                options={childIds}
            >
                {childIds.map((childId) => {
                    const obj = objects[childId];
                    const childLabel =
                        obj?.data?.heading ||
                        obj?.data?.name ||
                        t("DocumentGenerator.Alternative", "Alternativ");
                    return (
                        <Radio
                            key={childId}
                            value={childId}
                            name={childLabel}
                            onBlur={onBlur}
                            onFocus={onFocus}
                        />
                    );
                })}
            </RadioGroup>
        </FormLabel>
    );
});

XAlternativesForm.displayName = "XAlternativesForm";
